import { GuidePriority } from "../guide";
import type { GuideScript } from "../guide";
import { featureEndSteps } from "./features";

/** Captain Bram on the level-end screen (DESIGN §6.3): the first chest, and a kind word after the first defeat. */
export const endScript: GuideScript = {
  id: "end",
  steps: [
    { id: "end.firstWin", kind: "do", pose: "cheering", screen: "end", priority: GuidePriority.Walkthrough, topic: "chests",
      target: { dom: ".end .open" }, block: "hard",
      text: "We did it, Commander! Tap **OPEN** and see what we've won.",
      when: (c) => c.end !== null && c.end.won && c.end.firstWin && !c.end.chestOpened,
      until: (c) => c.end?.chestOpened === true || c.signals.has("chestOpened") },
    { id: "end.firstLoss", kind: "info", pose: "neutral", screen: "end", priority: GuidePriority.Safety,
      placement: "bottom",
      text: "Chin up, Commander: every defeat teaches us something. Upgrade a tower at the fortress and go again.",
      when: (c) => c.end !== null && !c.end.won && c.end.firstLoss },
    ...featureEndSteps,
  ],
};
